import { useState } from 'react';
import { toast } from 'react-toastify';

const INFO = [
  { icon: '📍', title: 'Visit Us', lines: ['Bhadralok Studio', '12/3 College Street, North Kolkata', 'West Bengal — 700073'] },
  { icon: '📞', title: 'Call Us', lines: ['+91 98765 43210', '+91 98765 43211', 'Mon–Sat, 10am–7pm IST'] },
  { icon: '📧', title: 'Email Us', lines: ['hello@bhadralok.com', 'support@bhadralok.com', 'We reply within 24 hours'] },
  { icon: '🕐', title: 'Store Hours', lines: ['Monday – Saturday', '10:00 AM – 8:00 PM', 'Sunday: 11:00 AM – 6:00 PM'] },
];

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    await new Promise((r) => setTimeout(r, 800));
    toast.success('Message sent! We\'ll get back to you within 24 hours.');
    setForm({ name: '', email: '', phone: '', subject: '', message: '' });
    setSending(false);
  };

  return (
    <div className="page-top">
      {/* Hero */}
      <div style={S.hero}>
        <div style={S.heroBg}>CONTACT</div>
        <div style={S.heroContent}>
          <p className="sec-label" style={{ color: 'var(--gold)', marginBottom: '10px' }}>We'd Love to Hear From You</p>
          <h1 style={S.heroTitle}>GET IN TOUCH</h1>
          <p style={S.heroSub}>Whether you have a question about an order, a collaboration idea, or just want to say namoshkar — we're here.</p>
        </div>
      </div>

      {/* Info Cards */}
      <div style={S.infoGrid}>
        {INFO.map((i) => (
          <div key={i.title} style={S.infoCard}>
            <div style={S.infoIcon}>{i.icon}</div>
            <p style={S.infoTitle}>{i.title}</p>
            {i.lines.map((l, idx) => (
              <p key={idx} style={{ fontSize: idx === 0 ? '13px' : '12px', color: idx === 0 ? 'var(--black)' : '#888', fontWeight: idx === 0 ? 600 : 400, lineHeight: 1.6, margin: '1px 0' }}>{l}</p>
            ))}
          </div>
        ))}
      </div>

      {/* Form + Map */}
      <div style={S.mainGrid}>
        {/* Form */}
        <div style={S.formCard}>
          <p className="sec-label" style={{ marginBottom: '8px' }}>Send a Message</p>
          <h2 style={S.formTitle}>WE'LL REPLY WITHIN <em style={{ color: 'var(--red)', fontStyle: 'italic' }}>24 HOURS</em></h2>
          <form onSubmit={handleSubmit} style={{ marginTop: '24px' }}>
            <div style={S.row}>
              <div style={{ flex: 1 }}>
                <label style={S.lbl}>Your Name *</label>
                <input style={S.inp} placeholder="Amit Chatterjee" value={form.name} onChange={set('name')} required />
              </div>
              <div style={{ flex: 1 }}>
                <label style={S.lbl}>Email Address *</label>
                <input style={S.inp} type="email" placeholder="amit@email.com" value={form.email} onChange={set('email')} required />
              </div>
            </div>
            <div style={S.row}>
              <div style={{ flex: 1 }}>
                <label style={S.lbl}>Phone Number</label>
                <input style={S.inp} placeholder="+91 9876543210" value={form.phone} onChange={set('phone')} />
              </div>
              <div style={{ flex: 1 }}>
                <label style={S.lbl}>Subject *</label>
                <select style={S.inp} value={form.subject} onChange={set('subject')} required>
                  <option value="">Select a topic...</option>
                  <option>Order Query</option>
                  <option>Return / Exchange</option>
                  <option>Product Information</option>
                  <option>Bulk / Corporate Order</option>
                  <option>Press & Collaboration</option>
                  <option>Other</option>
                </select>
              </div>
            </div>
            <label style={S.lbl}>Your Message *</label>
            <textarea style={{ ...S.inp, height: '140px', resize: 'vertical' }} placeholder="Tell us what's on your mind..." value={form.message} onChange={set('message')} required />
            <button type="submit" style={S.submitBtn} disabled={sending}>
              {sending ? 'SENDING...' : 'SEND MESSAGE →'}
            </button>
          </form>
        </div>

        {/* Sidebar */}
        <div>
          {/* Map placeholder */}
          <div style={S.mapBox}>
            <div style={S.mapOverlay}>
              <p style={S.mapLabel}>📍 College Street, Kolkata</p>
            </div>
          </div>

          {/* Social Links */}
          <div style={S.socialCard}>
            <p style={S.socialTitle}>FOLLOW US</p>
            {[
              { icon: 'IG', name: 'Instagram', handle: '@bhadralok.official' },
              { icon: 'FB', name: 'Facebook', handle: 'Bhadralok Official' },
              { icon: 'TW', name: 'Twitter / X', handle: '@bhadralok_' },
              { icon: 'YT', name: 'YouTube', handle: 'Bhadralok TV' },
            ].map((s) => (
              <div key={s.name} style={S.socialRow}>
                <div style={S.socialIcon}>{s.icon}</div>
                <div>
                  <p style={{ fontSize: '12px', fontWeight: 700, margin: 0 }}>{s.name}</p>
                  <p style={{ fontSize: '11px', color: '#888', margin: 0 }}>{s.handle}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const S = {
  hero:        { background: 'var(--black)', padding: '60px 56px 52px', position: 'relative', overflow: 'hidden', borderBottom: '4px solid var(--gold)' },
  heroBg:      { position: 'absolute', right: '-20px', top: '50%', transform: 'translateY(-50%)', fontFamily: 'var(--font-display)', fontSize: 'clamp(80px,12vw,160px)', letterSpacing: '-4px', color: 'rgba(255,255,255,.04)', lineHeight: 1, userSelect: 'none', pointerEvents: 'none' },
  heroContent: { position: 'relative', zIndex: 1 },
  heroTitle:   { fontFamily: 'var(--font-display)', fontSize: 'clamp(32px,5vw,56px)', letterSpacing: '2px', color: '#fff', lineHeight: 1, marginBottom: '14px' },
  heroSub:     { fontSize: '14px', color: 'rgba(255,255,255,.5)', lineHeight: 1.8, maxWidth: '480px' },
  infoGrid:    { display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '0', borderBottom: '1px solid var(--border)', background: '#fff' },
  infoCard:    { padding: '28px 24px', borderRight: '1px solid var(--border)' },
  infoIcon:    { fontSize: '24px', marginBottom: '10px' },
  infoTitle:   { fontFamily: 'var(--font-display)', fontSize: '14px', letterSpacing: '2px', marginBottom: '8px', color: 'var(--black)' },
  mainGrid:    { display: 'grid', gridTemplateColumns: '1fr 360px', gap: '32px', padding: '48px 56px 80px', background: 'var(--offwhite)', maxWidth: '1200px', margin: '0 auto' },
  formCard:    { background: '#fff', border: '1px solid var(--border)', padding: '36px' },
  formTitle:   { fontFamily: 'var(--font-display)', fontSize: '22px', letterSpacing: '2px', lineHeight: 1.1 },
  row:         { display: 'flex', gap: '14px', marginBottom: '0' },
  lbl:         { display: 'block', fontSize: '10px', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase', color: '#777', marginBottom: '5px', marginTop: '14px' },
  inp:         { width: '100%', border: '1.5px solid var(--border)', background: 'var(--offwhite)', padding: '10px 13px', fontFamily: 'var(--font-body)', fontSize: '13px', outline: 'none', boxSizing: 'border-box', transition: 'border-color .2s' },
  submitBtn:   { marginTop: '20px', padding: '14px 36px', background: 'var(--red)', color: '#fff', border: 'none', fontFamily: 'var(--font-body)', fontSize: '11px', fontWeight: 700, letterSpacing: '2px', textTransform: 'uppercase', cursor: 'pointer', transition: 'opacity .2s' },
  mapBox:      { height: '240px', background: 'var(--black)', position: 'relative', marginBottom: '16px', overflow: 'hidden', backgroundImage: 'url(https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=600&q=60)', backgroundSize: 'cover', backgroundPosition: 'center' },
  mapOverlay:  { position: 'absolute', inset: 0, background: 'rgba(0,0,0,.5)', display: 'flex', alignItems: 'flex-end', padding: '16px' },
  mapLabel:    { fontSize: '13px', color: '#fff', fontWeight: 600, background: 'rgba(0,0,0,.6)', padding: '6px 12px', borderLeft: '3px solid var(--gold)' },
  socialCard:  { background: '#fff', border: '1px solid var(--border)', padding: '20px' },
  socialTitle: { fontFamily: 'var(--font-display)', fontSize: '13px', letterSpacing: '2.5px', marginBottom: '14px', color: '#888' },
  socialRow:   { display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 0', borderBottom: '1px solid var(--border)' },
  socialIcon:  { width: '32px', height: '32px', background: 'var(--black)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '9px', fontWeight: 700, color: '#fff', letterSpacing: '.5px', flexShrink: 0 },
};
